import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onSearch", "placeholder", "options", "marginBottom"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AutoComplete } from 'antd';
import styled from 'styled-components';
import { styleVariables } from '../style';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAutoComplete = styled(AutoComplete).withConfig({
  displayName: "auto-completecomponent__StyledAutoComplete",
  componentId: "sc-q5cmx6-0"
})(["margin-bottom:", ";width:588px;&:not(.ant-select-disabled) .ant-select-selector{height:50px;display:flex;align-items:center;border-radius:10px;border:1px solid ", ";}&:not(.ant-select-disabled):hover .ant-select-selector{border-color:", ";border-radius:10px;}.ant-select-selection-search-input{height:50px !important;}"], function (props) {
  return props.marginBottom || '16px';
}, styleVariables.colors.grey14, styleVariables.colors.blue4);
export var AutoCompleteComponent = function AutoCompleteComponent(_ref) {
  var onSearch = _ref.onSearch,
      placeholder = _ref.placeholder,
      options = _ref.options,
      marginBottom = _ref.marginBottom,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(StyledAutoComplete, _objectSpread(_objectSpread({}, props), {}, {
    onSearch: onSearch,
    placeholder: placeholder,
    options: options,
    marginBottom: marginBottom
  }));
};